'use strict';
module.exports = require('./dist/index');